import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TaskReview, TimeBlock } from 'src/models/changeover-review';
import { LinkedTaskReview, LinkedTimeBlock, TimeDivision } from '../review.component';
import LayoutHelper from '../layout-helper';

@Component({
  selector: 'app-gantt',
  templateUrl: './gantt.component.html',
  styleUrls: ['./gantt.component.scss']
})
export class GanttComponent {
  @Input()
  tasks: Array<LinkedTaskReview> = [];

  _selectedTimeBlock: LinkedTimeBlock | null = null;
  get selectedTimeBlock(): LinkedTimeBlock | null { return this._selectedTimeBlock; }
  @Input()
  set selectedTimeBlock(value: LinkedTimeBlock | null) {
    this._selectedTimeBlock = value;
    this.selectedTimeBlockChanged.emit(this.selectedTimeBlock);
  }

  @Input()
  layoutHelper!: LayoutHelper;
  @Input()
  timeDivisions!: Array<TimeDivision>;

  @Output()
  selectedTimeBlockChanged = new EventEmitter<LinkedTimeBlock | null>();

  constructor() { }

  isOverdue = (task: TaskReview, timeBlock: TimeBlock): boolean =>
    !task.isOngoing &&
    task.isOverdue &&
    timeBlock.isActive &&
    (timeBlock.startOffsetInMinutes + timeBlock.durationInMinutes) > task.standardEndOffsetInMinutes!;
  isSelected = (timeBlock: LinkedTimeBlock): boolean => this.selectedTimeBlock === timeBlock;

  clearSelection = () => this.selectTimeBlock();
  selectTimeBlock = (selection?: LinkedTimeBlock, event?: MouseEvent): void => {
    event?.stopImmediatePropagation();
    this.selectedTimeBlock = selection || null;
  }

  getDefinitionUrl(definitionId: string): string {
    return `url(${location.href}#${definitionId})`;
  }

  hasNote = GanttComponent.hasNote;
  needsNote = GanttComponent.needsNote;

  static hasNote = (block: TimeBlock) => block.operatorNoteReason !== null;
  static needsNote = (block: TimeBlock) => !GanttComponent.hasNote(block) && block.type === 'Pause';
}
